/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import { RichTextComponent } from '@msdyn365-commerce/core';
import AccordionItem from 'mfcl/AccordionItem';
import * as React from 'react';
import _getViewPort from '../../Utilities/get-view-port';
import { IMfrmBaseFaqsData } from './mfrm-base-faqs.data';
import { IFaqListData, IMfrmBaseFaqsProps } from './mfrm-base-faqs.props.autogenerated';

export interface IMfrmBaseFaqsViewProps extends IMfrmBaseFaqsProps<IMfrmBaseFaqsData> {
    baseFaqsContent: React.ReactNode;
}

/**
 *
 * MfrmBaseFaqs component
 * @extends {React.FC<IMfrmBaseFaqsProps<IMfrmBaseFaqsData>>}
 */
class MfrmBaseFaqs extends React.PureComponent<IMfrmBaseFaqsProps<IMfrmBaseFaqsData>> {
    constructor(props: IMfrmBaseFaqsProps<IMfrmBaseFaqsData>) {
        super(props);
    }
    public render(): JSX.Element | null {
        const viewProps = {
            ...(this.props as IMfrmBaseFaqsProps<IMfrmBaseFaqsData>),
            baseFaqsContent: this._showFAQAccordion()
        };
        return this.props.renderView(viewProps);
    }
    private _showFAQAccordion = (): JSX.Element | undefined => {
        const faqHeader = this.props.config.faqHeader;
        const faqAccordionContent = this.props.config.faqList;
        const {
            data: {
                productSpecificationData: { result }
            },
            config: { backendAttribute }
        } = this.props;
        const isAdjsutableBaseProduct =
            result && backendAttribute
                ? result.find(obj => obj.Name && obj.Name.toLowerCase().trim() === backendAttribute.toLowerCase().trim())?.TextValue
                : undefined;
        return (
            <>
                {isAdjsutableBaseProduct && isAdjsutableBaseProduct.length > 0 ? (
                    <div className='mfrm-accordion-container mfrm-accordion__faq'>
                        <h2>{faqHeader}</h2>
                        <div className='mfrm-accordion'>
                            {faqAccordionContent &&
                                faqAccordionContent.length &&
                                faqAccordionContent.map((item: IFaqListData, index: number) => (
                                    <AccordionItem
                                        className='mfrm-accordion__item'
                                        key={index}
                                        title={item.faqQuestion || ''}
                                        id={item.faqQuestion || ''}
                                        content={<RichTextComponent text={item.faqAnswer} />}
                                        focused={0}
                                    />
                                ))}
                        </div>
                    </div>
                ) : null}
            </>
        );
    };
}

export default MfrmBaseFaqs;
